import React, {useEffect, useState} from "react";
import FilteringAccordionItem from "../../atoms/filtering-accordion-item/filtering-accordion-item";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../../../store/configureStore";
import {clubFinderSearchBarSliceActions} from "../../../../store/slices/clubFinderSearchBarSlice";

const DaysFilterComponent = (props: any): JSX.Element => {
  const dispatch = useDispatch();

  const selectedDayFilter = useSelector((state: RootState) => state.clubFinderSearchBarStore.selectedDayFilters);
  const [savedDay, setSavedDay] = useState([]);

  const handleDayFilterOption = (dayOption: any) => {
    if (savedDay && selectedDayFilter) {
      //Local State Change
      const tempSavedDay = [...savedDay]
      // @ts-ignore
      const index = tempSavedDay.indexOf(dayOption);

      if (index !== -1) {
        tempSavedDay.splice(index, 1);
        setSavedDay([...tempSavedDay]);
        dispatch(clubFinderSearchBarSliceActions.setSavedDayFilter([...tempSavedDay]))
      } else {
        // @ts-ignore
        tempSavedDay.push(dayOption)
        setSavedDay([...tempSavedDay]);
        dispatch(clubFinderSearchBarSliceActions.setSavedDayFilter([...tempSavedDay]))
      }
    } else {
      // @ts-ignore
      setSavedDay([dayOption]);
      dispatch(clubFinderSearchBarSliceActions.setSavedDayFilter([dayOption]))
    }
  }

  useEffect(() => {
    if (selectedDayFilter == null) {
      setSavedDay([]);
    } else {
      const daysValue = selectedDayFilter.map((item: any) => item);
      setSavedDay(daysValue );
    }
  },[selectedDayFilter])

  return (
    <FilteringAccordionItem accordionTitle={'Day (programs only)'} filterOption={props.daysFilterOptions}
                            filterType={'days'} key={'days'} handleFilterOption={(dayOption: any) => handleDayFilterOption(dayOption)} selectedDayOption={savedDay}/>
  )
}

export default DaysFilterComponent;
